import type { AnyRouter } from "@tanstack/react-router";

import { getFaro } from "./faro";

const setFaroView = (name: string) => getFaro()?.api.setView({ name });

// faro stamps the current view on every event it sends, which turns "what
// page was the user on" into a field instead of a guess from fetch urls
export function trackRouteViews(
  router: AnyRouter,
  onView: (name: string) => void = setFaroView,
): () => void {
  return router.subscribe("onResolved", () => {
    const page = router.state.matches.at(-1);
    if (page) onView(page.routeId);
  });
}
